import { FC } from 'react';

import styles from 'pages/AdCreateMenu/AdCreateMenu.module.less';

import { CampaignCreationWizard } from 'components/CampaignCreationWizard/CampaignCreationWizard';
import { Header } from 'components/Header/Header';

const AdCreateMenu: FC = () => (
    <div className={styles.wrapper}>
        <Header />
        <CampaignCreationWizard />
    </div>
);

export default AdCreateMenu;
